import { ObjectMapper } from "json-object-mapper";
import { IModel } from "../IModel";
import { Model } from "../model";
import { FormGroupModel } from "./form-group.model";
import { FormType } from "./enum/form-type.enum";
import { FormStatusType } from "./enum/form-status-type.enum";

export class FormModel extends Model implements IModel<FormModel> {
    public companyGroupId: string = "";
    public conclusionContent: string = "";
    public description: string = "";
    public status: number = 0;
    public groups: FormGroupModel[] = [];
    public introductionContent: string = "";
    public submission: any[] = [];
    public title: string = "";
    public type: number = 0;

    get enableBadge(): string {
        const status = {
            label: this.enable ? "Ativo" : "Inativo",
            className: this.enable ? "success" : "danger",
        };

        return `<span class="badge bg-light-${status?.className} text-wrap">${status?.label}</span>`;
    }

    get statusBadge(): string {
        const status = FormStatusType.getById(this.status);
        return `<span class="badge bg-light-${status?.className} text-wrap">${status?.label}</span>`;
    }

    get checkChangeDate(): string | null {
        if (
            !this.changeDate ||
            this.changeDate === "0001-01-01T00:00:00.000" ||
            this.changeDate === "-infinity"
        ) {
            return null;
        }
        return this.changeDate;
    }

    public typeData() {
        return FormType.getById(this.type);
    }

    static create(input: any): FormModel {
        return ObjectMapper.deserialize<FormModel>(FormModel, input);
    }

    public toJSON(): string {
        return ObjectMapper.serialize(this) as string;
    }
}
